import apiClient from './client';

export interface Trainer {
  id: number;
  name: string;
  email?: string;
  phone?: string;
  trainingMap?: string;
  city?: string;
  state?: string;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TrainerFilters {
  page?: number;
  limit?: number;
  search?: string;
  trainingMap?: string;
  city?: string;
  state?: string;
  isActive?: boolean;
}

export interface CreateTrainerData {
  name: string;
  email?: string;
  phone?: string;
  trainingMap?: string;
  city?: string;
  state?: string;
  notes?: string;
}

export interface UpdateTrainerData {
  name?: string;
  email?: string;
  phone?: string;
  trainingMap?: string;
  city?: string;
  state?: string;
  notes?: string;
  isActive?: boolean;
}

class TrainerService {
  async getAllTrainers(filters: TrainerFilters = {}) {
    const response = await apiClient.get('/trainers', { params: filters });
    return response.data;
  }

  async getTrainer(id: number) {
    const response = await apiClient.get(`/trainers/${id}`);
    return response.data;
  }

  async createTrainer(data: CreateTrainerData) {
    const response = await apiClient.post('/trainers', data);
    return response.data;
  }

  async updateTrainer(id: number, data: UpdateTrainerData) {
    const response = await apiClient.put(`/trainers/${id}`, data);
    return response.data;
  }

  async deleteTrainer(id: number) {
    const response = await apiClient.delete(`/trainers/${id}`);
    return response.data;
  }

  async getTrainersByMap(trainingMap: string) {
    const response = await apiClient.get(`/trainers/by-map/${trainingMap}`);
    return response.data;
  }

  async getTrainersByLocation(city?: string, state?: string) {
    const response = await apiClient.get('/trainers/by-location', {
      params: { city, state },
    });
    return response.data;
  }
}

export const trainerService = new TrainerService();

